import { render } from "./Service.vue?vue&type=template&id=ac6521a8&scoped=true"
import script from "./Service.vue?vue&type=script&lang=js"
export * from "./Service.vue?vue&type=script&lang=js"

import "./Service.vue?vue&type=style&index=0&id=ac6521a8&scoped=true&lang=css"

import exportComponent from "/Users/yinhu/code/jugu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac6521a8"]])

export default __exports__